export default {
        title: 'Spectrum Analysis Tools',
	actions: {
		add: 'Add',
		edit: 'Edit',
		delete: 'Delete',
		batchDelete: 'Batch Delete',
		save: 'Save',
		cancel: 'Cancel',
		confirm: 'Confirm'
	},
	messages: {
		deleteConfirm: 'Are you sure you want to delete the selected {count} records?',
		deleteSuccess: 'Operation successful',
		selectDeleteWarning: 'Please select the records to delete',
		operateSuccess: 'Operation successful',
		requiredFieldCannotBeEmpty: 'Required field cannot be empty'
	},
	form: {
		name: 'Name',
		placeholder: {
			name: 'Please enter name'
		}
	},
	table: {
		id: 'ID',
                name: 'Spectrum Type Name',
		toolCode: 'Code',
		icon: 'Icon',
		sort: 'Sort'
	},
	widgetForm: {
		id: 'ID',
                name: 'Spectrum Type Name',
		toolCode: 'Code',
		icon: 'Icon',
		sort: 'Sort',
		remark: 'Remark',
		gridLayout: 'Grid Layout',
		requiredFieldCannotBeEmpty: 'Required field cannot be empty',
		placeholder: {
			id: 'Please enter ID',
                        name: 'Please enter spectrum type name',
			toolCode: 'Please enter code',
			icon: 'Please select icon',
			sort: 'Please enter sort',
			remark: 'Please enter remark'
		}
	},
	dialog: {
		add: 'Add',
		edit: 'Edit',
		cancel: 'Cancel',
		confirm: 'Confirm'
	}
}
